import { render, staticRenderFns } from "./DomainDistribution.vue?vue&type=template&id=89ab9464&scoped=true"
import script from "./DomainDistribution.vue?vue&type=script&lang=js"
export * from "./DomainDistribution.vue?vue&type=script&lang=js"
import style0 from "./DomainDistribution.vue?vue&type=style&index=0&id=89ab9464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ab9464",
  null
  
)

export default component.exports